/**
 * Google Analytics 4 (GA4) tracking utility
 * Handles page views and custom events for React Router navigation
 */

// Store measurement ID globally for reuse
let gaMeasurementId = null;

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (typeof window !== "undefined" && measurementId) {
    gaMeasurementId = measurementId;

    // Add gtag script to document
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag("js", new Date());
    gtag("config", measurementId, {
      page_path: window.location.pathname,
    });

    console.log("Google Analytics initialized:", measurementId);
  }
};

// Track page view
export const trackPageView = (path) => {
  if (typeof window !== "undefined" && window.gtag && gaMeasurementId) {
    // Use page_view event for GA4 (proper way to track route changes)
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.origin + path,
    });
    console.log("GA4 page view tracked:", path);
  } else {
    console.warn("GA4 not ready or measurement ID missing. Path:", path);
  }
};

// Track custom event
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, eventParams);
    console.log("GA4 event tracked:", eventName, eventParams);
  }
};
